//该页面专门用于维护路由器
 
//引入vue-router
import Vrouter from 'vue-router'
 
 
//创建并暴露 路由器
export default new Vrouter({
	mode: 'history',
    routes:[
        {
            name:'首页',//命名路由,:to="{name='banji'}"
            path:'/',  //当路径是 /class时，内容区就显示ClassPage这个组件。
            component: () => import('../components/Index'),
        },
		{
		    path:'/list',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/list'), 
		},
		{
		    path:'/new_details',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/new_details'), 
		},
		{
		    path:'/quick',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/quick'), 
		},
		{
		    path:'/qzss',  //当路径是 /class时，内容区就显示ClassPage这个组件。
		    component: () => import('../components/qzss'), 
		}
		
    ],
	scrollBehavior (to, from, savedPosition) {
	    if (savedPosition) {
	      return savedPosition
	    } else {
	      return { x: 0, y: 0 }
	    }
	}
});